export const DEBUG_MODE_KEY = "debugMode";
export const SILENT_TOASTS_KEY = "silentToasts";
export const TOASTER_POSITION_KEY = "toasterPosition";
export const MFA_ENROLLMENT_PROMPT_DISMISSED_KEY_PREFIX = "mfa-enrollment-prompt";
